import React from "react";
import { Collapse, Divider } from "antd";
import IconInfoImage from "assets/Icon-Info.svg";
import "styles/AtarEligible.scss";
const Panel = Collapse.Panel;

const AtarEligibilityInfo = () => {
  const eligibilityHeading = (
    <h3 className="label" style={{ marginBottom: 5 }}>
      <span className="margin-right">
        <img src={IconInfoImage} alt="Information" />
      </span>
      ATAR eligibility rules
    </h3>
  );

  const eligibilityDotpoints = (
    <ul className="eligibility-dotpoints">
      <li>10 units of Board Developed courses</li>
      <li>2 units of English</li>
      <li>3 Board Developed courses of 2 units or greater</li>
      <li>4 subject areas</li>
    </ul>
  );

  return (
    <div className="eligibility-container">
      <div className="desktop-and-tablet margin-top">
        {eligibilityHeading}
        <Divider className="margin-top margin-bottom" />
        <h3 className="label">You must complete</h3>
        {eligibilityDotpoints}
      </div>
      <div className="mobile-only">
        <Collapse bordered={false} className="atar-eligibility-info-collapse">
          <Panel
            header={
              <span
                className="field-list-title selected margin-left"
                style={{ paddingLeft: 10 }}
              >
                {eligibilityHeading}
              </span>
            }
            className="field-list-panel"
          >
            <h3 className="label">You must complete</h3>
            {eligibilityDotpoints}
          </Panel>
        </Collapse>
      </div>
    </div>
  );
};

export default AtarEligibilityInfo;
